export const defaultFormConfirmationDialogMessageParams = {
  message: 'Confirm closing the form',
  description: 'Are you sure you want to close this form? All unsaved data will be lost.',
};

export const NO_AVAILABLE_SECTION_DATA_MESSAGE =
  'Sorry, but there is no data available for this section';
